<template>
  <v-container fluid grid-list-xl>
    <v-layout v-if="tournament._id" row wrap>
      <v-flex xs12 sm6 md4 lg3 v-for="(match, index) in localMatches" :key="index +1200">
        <match-video-card
          :match="match"
          :type="tournament.type"
          :phaseInfo="phaseInfo(match._id)"
          @open="open()"
          :key="match._id + index"
        />
      </v-flex>
    </v-layout>
    <v-dialog fullscreen lazy v-model="modal">
      <v-card>
        <v-flex xs12 text-xs-right my-0>
          <v-btn @click="close()" icon class="my-0">
            <v-icon color="primary">close</v-icon>
          </v-btn>
        </v-flex>
        <tab-events v-if="modal" :tabVideoView="true"></tab-events>
        <v-flex xs12 text-xs-right my-0>
          <v-btn @click="close()" color="primary" small>{{$t('cancel')}}</v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MatchVideoCard from './MatchVideoCard'
import tabEvents from '../../matches/tabEvents'

export default {
  name: 'tabVideos',
  components: { MatchVideoCard, tabEvents },
  data () {
    return {
      modal: false
    }
  },
  computed: {
    ...mapState({
      tournament: state => state.tournaments.selected
    }),
    localMatches () {
      if (!this.tournament || !this.tournament._id) { return [] }

      return this.tournament.matches
        .filter(match => match.video || match.youtubeVideo)
    }
  },
  methods: {
    ...mapActions({
      setClearOne: 'matches/setClearOne'
    }),
    close () {
      this.modal = false
      const vm = this
      setTimeout(() => {
        vm.setClearOne()
      }, 1000)
    },
    open () {
      this.modal = true
    },
    phaseInfo (matchId) {
      let phases = this.tournament.phases
      let phase = ''
      let group = ''
      phases.forEach(_phase => {
        _phase.groups.forEach(_group => {
          if (_group.matches.includes(matchId)) {
            phase = this.getName(_phase.name)
            group = this.getName(_group.name)
          }
        })
      })
      return { phase, group }
    }
  }
}
</script>

<style scoped lang="scss">
.v-content {
}
</style>
